/**
 * StyledSelect
 * 
 * @Author: Focci
 * @Date: 2023-08-06 11:06:34
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-06 11:06:34
 */

import { forwardRef } from 'react'
import { Select, MenuItem } from '@comp/material'

function StyledSelect({
  options = [],
  ...props
}, ref) {
  const sx = (theme) => {
    const tmp = {
      fontSize: '.7rem',
      width: '100%',
      '& .MuiSelect-select': {
        paddingTop: '.6rem',
        paddingBottom: '.6rem',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#9b9b9b'
      },
      '&.MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#9b9b9b!important'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: '1px'
      }
    }

    return tmp
  }

  return (
    <Select {...props} sx={sx} ref={ref}>
      {options.map((opt) => (
        <MenuItem
          key={opt.value}
          value={opt.value}
          sx={{ fontSize: '1em' }}
        >
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  )
}

export default forwardRef(StyledSelect)
